<div id="shipperDetails" class="pr-2" [formGroup]="shipmentForm">
  <div class="secondary-details mb-2">
    <span>{{ 'shipment.shipmentInfo.shipmentDetails' | translate }}</span>
  </div>
  <div class="row">
    <div class="col-md-3 form-group">
      <div class="row">
        <label class="required-field"
          >{{ 'shipment.shipmentInfo.shipmentDate' | translate }}:</label
        >
        <div style="display: inline-flex">
          <input [matDatepicker]="to" class="form-control" formControlName="shipmentDate" />
          <mat-datepicker-toggle matSuffix [for]="to">
            <em class="bi bi-calendar2-check icon-mat" alt="calendar" matDatepickerToggleIcon></em>
          </mat-datepicker-toggle>
          <mat-datepicker #to></mat-datepicker>
        </div>
        <small
          class="text-danger"
          *ngIf="
            shipmentForm.get('shipmentDate').errors && shipmentForm.get('shipmentDate').touched
          "
          >{{ 'shipment.shipmentInfo.dateValidationLabel' | translate }}
        </small>
      </div>
    </div>
    <!-- <div class="col-md-3 form-group">
      <label class="required-field">Product Code</label>:
      <input class="form-control" type="text" formControlName="productCode" />
      <small
        class="text-danger"
        *ngIf="shipmentForm.get('productCode').errors && shipmentForm.get('productCode').touched"
        >Please enter Product code B
      </small>
    </div> -->
    <!-- <div class="col-md-3 form-group">
      <label>Local Product Code: </label>
      <input class="form-control" type="text" formControlName="localProductCode" />
      <small class="text-danger" *ngIf="shipmentForm.get('localProductCode').errors"
        >Please enter Product code B
      </small>
    </div> -->
    <!-- <div class="col-md-3 form-group">
      <label>Shipper Account Number</label>:
      <input class="form-control" type="text" formControlName="shipperAccountNumber" />
      <app-error-component [controlName]="shipmentForm.get('shipperAccountNumber')"></app-error-component>
    </div> -->
    <!-- <div class="col-md-3 form-group">
      <label>Payer Account Number</label>:
      <input class="form-control" type="text" formControlName="payerAccountNumber" />
      <app-error-component [controlName]="shipmentForm.get('payerAccountNumber')"></app-error-component>
    </div> -->
    <!-- <div class="col-md-3 form-group">
      <label>Duty Account Number</label>:
      <input class="form-control" type="text" formControlName="dutyAccountNumber" />
      <app-error-component [controlName]="shipmentForm.get('dutyAccountNumber')"></app-error-component>
    </div> -->
    <div class="col-md-3 form-group">
      <label class="required-field"
        >{{ 'shipment.shipmentInfo.shipperReference' | translate }}:
      </label>
      <input class="form-control" type="text" formControlName="shipperReference" />
      <app-error-component
        [controlName]="shipmentForm.get('shipperReference')"></app-error-component>
    </div>
    <div class="col-md-3 form-group">
      <label>{{ 'shipment.shipmentInfo.shipmentID' | translate }}: </label>
      <input class="form-control" type="text" formControlName="shipmentID" />
      <app-error-component [controlName]="shipmentForm.get('shipmentID')"></app-error-component>
      <span class="msg" *ngIf="!isValidShipmentID">{{
        'shipment.shipmentInfo.invalidShipmentID' | translate
      }}</span>
    </div>
    <div class="col-md-3 form-group">
      <label class="required-field">{{
        'shipment.shipmentInfo.shipmentContentsDescription' | translate
      }}</label
      >:
      <input class="form-control" type="text" formControlName="shipmentContentsDescription" />
      <app-error-component
        [controlName]="shipmentForm.get('shipmentContentsDescription')"></app-error-component>
    </div>
    <!-- <div class="col-md-3 form-group">
      <label>DGContent ID: </label>
      <mat-form-field appearance="none">
        <mat-select disableRipple class="form-control" formControlName="serviceCode">
          <mat-option *ngFor="let dgContentId of serviceCodes" [value]="eachId">
            {{ eachId }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-error-component [controlName]="shipmentForm.get('DGContentID')"></app-error-component>
    </div>
    -->

    <div class="col-md-3 form-group">
      <label
        [ngClass]="{
          'required-field':
            shipmentForm.get('isCustomsDeclarable').value === 'Y' ||
            shipmentForm.get('receiverDetails').get('receiverCountryCode').value === 'US' ||
            customsDeclarableValue
        }"
        >{{ 'shipment.shipmentInfo.shipmentDeclaredValue' | translate }}</label
      >:
      <input
        [required]="
          shipmentForm.get('isCustomsDeclarable').value === 'Y' ||
          shipmentForm.get('receiverDetails').get('receiverCountryCode').value === 'US' ||
          customsDeclarableValue
        "
        class="form-control"
        type="text"
        formControlName="shipmentDeclaredValue" />
      <app-error-component
        [controlName]="shipmentForm.get('shipmentDeclaredValue')"></app-error-component>
    </div>
    <div class="col-md-3 form-group">
      <label
        [ngClass]="{
          'required-field': shipmentForm.get('isCustomsDeclarable').value === 'Y'
        }"
        >{{ 'shipment.shipmentInfo.shipmentDeclaredValueCurrency' | translate }}</label
      >
      <select
        class="form-control"
        [required]="shipmentForm.get('isCustomsDeclarable').value === 'Y'"
        type="text"
        formControlName="shipmentDeclaredValueCurrency"
        (change)="onShipCurrencyChange($event.target.value)">
        <option class="option" *ngFor="let currency of currencyValues" [value]="currency">
          {{ currency }}
        </option>
      </select>
      <app-error-component
        [controlName]="shipmentForm.get('shipmentDeclaredValueCurrency')"></app-error-component>
      <span class="msg" *ngIf="misMatchInCurrency">{{
        'shipment.shipmentInfo.lineItemCurrencyValidationLabel' | translate
      }}</span>
    </div>
    <!-- <div class="col-md-3 form-group" *ngIf="dgContentIds?.length">
      <label>DG Content ID: </label>
      <mat-form-field appearance="none">
        <mat-select
          disableRipple
          class="form-control"
          formControlName="DGContentID"
          (selectionChange)="selectContentID($event)">
          <mat-option *ngFor="let contentID of dgContentIds" [value]="contentID.dg_content_id">
            {{ contentID.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="col-md-3 form-group" *ngIf="dgContentIds?.length">
      <label>{{ 'shipment.shipmentInfo.dGContentID' | translate }}:</label>
      <mat-form-field appearance="none" class="w-100">
        <mat-select
          disableRipple
          class="form-control"
          formControlName="DGContentID"
          multiple
          (selectionChange)="selectContentID($event)">
          <mat-option *ngFor="let eachId of dgContentIds" [value]="eachId?.dg_content_id">
            {{ eachId?.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="row">
        <div
          class="col-12 no-margin"
          *ngIf="dgSelected(enumDGPackage.BiologicalSubstance) || dgSelected(enumDGPackage.DryIce)">
          <mat-tab-group mat-align-tabs="start" [(selectedIndex)]="selectedDGTabIndex">
            <mat-tab *ngFor="let dg of selectedDGPackage" label="{{ dg.name }}"></mat-tab>
          </mat-tab-group>
        </div>

        <div
          [style.display]="selectedDGTabIndex == i ? 'block' : 'none'"
          *ngFor="let dg of selectedDGPackage; let i = index">
          <div *ngIf="dg.dg_content_id == enumDGPackage.BiologicalSubstance">
            <app-dgpackages
              [DGType]="dg.dg_content_id"
              (valueChange)="dgPackageBiologicalValueChange($event)"
              [(value)]="dgPackageBiologicalValue"></app-dgpackages>
          </div>
          <div *ngIf="dg.dg_content_id == enumDGPackage.DryIce">
            <app-dgpackages
              [DGType]="dg.dg_content_id"
              (valueChange)="dgPackageDryIcelValueChange($event)"
              [(value)]="dgPackageDryIcelValue"></app-dgpackages>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 form-group" *ngIf="customDescriptions?.length && contentID">
      <label class="required-field">{{
        'shipment.shipmentInfo.dGCustomDescription' | translate
      }}</label
      >:
      <mat-form-field appearance="none">
        <mat-select
          disableRipple
          class="form-control"
          formControlName="DGCustomDescription"
          [(value)]="selectedDescription"
          (selectionChange)="selected($event)">
          <mat-option
            [matTooltip]="description"
            *ngFor="let description of customDescriptions"
            [value]="description">
            {{ description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-error-component
        [controlName]="shipmentForm.get('DGCustomDescription')"></app-error-component>
    </div>

    <div class="col-md-3 form-group">
      <label class="required-field">{{ 'shipment.shipmentInfo.productName' | translate }}</label
      >:
      <mat-form-field appearance="none" class="w-100">
        <mat-select
          [disabled]="
            shipmentForm.get('status').value != null &&
            shipmentForm.get('status').value !== '' &&
            shipmentForm.get('status').value !== 'Draft'
          "
          disableRipple
          class="form-control"
          formControlName="productCode"
          (selectionChange)="selectProductName($event)">
          <mat-option *ngFor="let eachId of productNameValues" [value]="eachId?.productCode">
            {{ eachId?.productName }} - {{ eachId?.productID }}
          </mat-option>
        </mat-select>
        <app-error-component [controlName]="shipmentForm.get('productCode')"></app-error-component>
      </mat-form-field>
      <!--DG Package Description-->
      <div
        class="row"
        *ngIf="dgSelected(enumDGPackage.BiologicalSubstance) || dgSelected(enumDGPackage.DryIce)">
        <label>Dangerous Goods Label Description:</label>
        <div *ngFor="let dg of dgPackageBiologicalValue">
          <label *ngIf="dg.packageNo > 0">
            {{ dg.packageNo }} Package UN3373 Biological Substance Category B
          </label>
        </div>
        <div *ngFor="let dg of dgPackageDryIcelValue">
          <label *ngIf="dg.packageNo > 0 && dg.packageWeight > 0">
            UN1845 Dry Ice, net weight {{ dg.packageNo }} x {{ dg.packageWeight }} kg
          </label>
        </div>
      </div>
      <!--DG Package Description-->
    </div>
  </div>
</div>
